import { render, staticRenderFns } from "./entrance.vue?vue&type=template&id=5156e1f4&scoped=true&"
var script = {}
import style0 from "./entrance.vue?vue&type=style&index=0&id=5156e1f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5156e1f4",
  null
  
)

export default component.exports